export default {
    DEFAULT_RADIUS: undefined,
    DEFAULT_SEARCH_PARAMS: {
        MIN: 0,
        MAX: 20,
    },
};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/config/hotel-search-params.js